import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'qs';

export const baseCMSQuery = fetchBaseQuery({
    baseUrl: `${process.env['ALGOTECH_CMS_URL']}/api`,
    prepareHeaders: (headers, { getState }) => {
        const { accessToken } = (getState() as AppStateSchema).session;

        if (accessToken) {
            headers.set('Backend-Authorization', `Bearer ${accessToken}`);
        }

        return headers;
    },
    paramsSerializer: (params) =>
        qs.stringify(params, {
            arrayFormat: 'repeat',
            allowDots: false,
            encode: true,
            delimiter: '&',
        }),
});
